module.exports = __webpack_public_path__ + "pc-top-assets/img/info-card.5465b97b.jpg";